<template src="./quickbookAccountDetails.template.html"></template>
<script>
    import VeeValidate from "vee-validate";
    import Vue from "vue";

    Vue.use(VeeValidate)
    export default{
        name: "quickbookIntegrationDetail",
        props:["parentComponentName","closeQuickBookAccoutPanel","getIntegrationList"],
        data(){
            return{
                quickbookAccountDetails: {},

            }

        },
        methods:{
            saveConnectionDetails(){
                let vm =this;               


                 vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_Acc_Commission_Config",
                    params: {    


                    },
                    callback: function (err, response) {
                        if(err){

                        }
                        if(response){

                        }

                        vm.closeQuickBookAccoutPanel();
                        vm.getIntegrationList();

                    },
                 })             



            }

        },
        watch:{},
        computed:{
            quickBookUserList() {
               return this.$store.getters.getQuickbookAccountList()
            }

        },
        mounted(){

        }
        
    }

</script>